import Overlay from "../utilities/overlay"
import { escListener, scrollLock, trapFocus, removeTrapFocus } from "../utilities/utils"

const overlay = new Overlay()
class Drawer extends HTMLElement {
  constructor() {
    super()
    this.close = this.close.bind(this)
    this.open = this.open.bind(this)

    this.miniCart = this
    this.miniCartInner = this.miniCart.querySelector(".mini-cart__sidebar")
    this.cartOpenButtons = document.querySelectorAll("button[name='cart-open']")
    this.body = document.querySelector("body")
  }

  connectedCallback() {
    // set mini cart parent to body
    if (this.miniCart.parentElement !== this.body) {
      this.body.appendChild(this.miniCart)
    }

    this.addEventListeners()
  }

  addEventListeners() {
    // add event listeners
    this.querySelector("#cart-close").addEventListener("click", this.close)
  }

  open() {
    document.body.classList.add("active", "minicart")
    overlay.open({
      attachElements: [this],
    })
    overlay.onClick(this.close.bind(this))

    requestAnimationFrame(() => {
      this.classList.add("open")
    })

    escListener(true, this.escCallBack.bind(this))
    scrollLock(true)
    overlay.open({
      attachElements: [this.miniCart],
    })
    overlay.onClick(this.close)
    this.miniCart.classList.add("open")
    this.miniCart.focus()
    trapFocus(this.miniCart, this.miniCartInner)
  }

  close() {
    this.miniCart.classList.remove("open")
    overlay.removeOnClick(this.close)
    overlay.close()

    requestAnimationFrame(() => {
      this.classList.remove("open")
    })

    escListener(false, this.escCallBack)
    scrollLock(false)
    removeTrapFocus(this.miniCart)
  }

  escCallBack() {
    this.close()
  }
}

if (!customElements.get("drawer-component")) {
  customElements.define("drawer-component", Drawer)
}
